import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Sticky-Telefon-invers.svg'


const _hoisted_1 = { class: "c-footer u-mar-t-4" }
const _hoisted_2 = { class: "o-container" }
const _hoisted_3 = { class: "c-footer__copyright u-pad-t-2" }
const _hoisted_4 = {
  key: 0,
  class: "c-footer__copyright-link",
  href: "tel:04037663366"
}
const _hoisted_5 = {
  key: 1,
  class: "c-footer__copyright-link",
  href: "tel:04037663222"
}
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, [
            (!_ctx.piniaStore.state.isMakler)
              ? (_openBlock(), _createElementBlock("a", _hoisted_4, _cache[0] || (_cache[0] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Kontakt Telefon"
                    }),
                    _createTextVNode(" 040 37663-366")
                  ], -1)
                ])))
              : (_openBlock(), _createElementBlock("a", _hoisted_5, _cache[1] || (_cache[1] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Kontakt Telefon"
                    }),
                    _createTextVNode(" 040 37663-222")
                  ], -1)
                ])))
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "delimiterOne" }, [
            _createElementVNode("a", {
              class: "c-footer__copyright-link",
              href: "https://www.gev-versicherung.de/datenschutz/"
            }, "Datenschutz"),
            _createTextVNode(" | "),
            _createElementVNode("a", {
              class: "c-footer__copyright-link",
              href: "https://www.gev-versicherung.de/informationen/impressum/"
            }, "Impressum")
          ], -1))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "c-footer__copyright" }, [
          _createElementVNode("span", null, "Grundeigentümer-Versicherung VVaG"),
          _createElementVNode("span", { class: "delimiterOne" }, "Große Bäckerstraße 7 | 20095 Hamburg")
        ], -1))
      ])
    ]),
    (_ctx.zeigeStoreData)
      ? (_openBlock(), _createElementBlock("pre", _hoisted_6, "    " + _toDisplayString(_ctx.piniaStore.state) + "\n  ", 1))
      : _createCommentVNode("", true)
  ], 64))
}